import React, { useEffect } from 'react';

const ChatScript = () => {
  
  useEffect(() => {
    var currentLanguage = navigator.language || navigator.userLanguage; 

    if (currentLanguage === 'zh' || currentLanguage === 'zh-CN') {
        removeScript('ze-snippet');

        const chineseChatScript = `(function(a, b, c, d, e, j, s) { a[d] = a[d] || function() { (a[d].a = a[d].a || []).push(arguments) }; j = b.createElement(c), s = b.getElementsByTagName(c)[0]; j.async = true; j.charset = 'UTF-8'; j.src = 'https://static.meiqia.com/widget/loader.js'; s.parentNode.insertBefore(j, s); })(window, document, 'script', '_MEIQIA'); _MEIQIA('entId', '918e162b7f730f43fe702ece66500694');`
        loadInlineScript('cn-snippet',chineseChatScript);        
    }    
    else  {
        removeScript('cn-snippet');
        loadScript('ze-snippet','https://static.zdassets.com/ekr/snippet.js?key=96e92737-3771-442e-9590-543dcdcfa37b');      
    }
  }, []);

  const loadScript = (id, scriptSrc) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = scriptSrc;
    script.async = true;    
    document.head.appendChild(script);
  };

  const loadInlineScript = (id, script) => {
    const inlineScript = document.createElement('script');
    inlineScript.id = id;
    inlineScript.textContent = script;
    document.head.appendChild(inlineScript);
  };

  const removeScript = (scriptId) => {    
    const scriptToRemove = document.getElementById(scriptId);
    if (scriptToRemove) {
        scriptToRemove.remove()                 
    }
  }
  
    
  
  return <></>;
};

export default ChatScript;